"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsImperialMeasurementUsed = void 0;
/* eslint-disable import/prefer-default-export */
const reselect_1 = require("reselect");
exports.selectIsImperialMeasurementUsed = (0, reselect_1.createSelector)((state) => state.unitOfMeasurement, (unitOfMeasurement) => unitOfMeasurement.isImperialMeasurementUsed);
